import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=4add8796&scoped=true"
import script from "./HistoryView.vue?vue&type=script&lang=js"
export * from "./HistoryView.vue?vue&type=script&lang=js"
import style0 from "./HistoryView.vue?vue&type=style&index=0&id=4add8796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add8796",
  null
  
)

export default component.exports